/*
 * Hedonist 2026 — UX mobile des fiches produit (Clarity, 23/10/2026)
 * ---------------------------------------------------------------------------
 * 1. État « Ajout… » sur le bouton dès le clic + ouverture immédiate du tiroir
 *    (voile « Ajout au panier… » jusqu'au rendu du panier).
 * 2. Barre d'achat fixe en bas d'écran sur mobile (prix + bouton) tant que le
 *    bouton principal n'est pas visible.
 * 3. AQUAPOP : ajout au panier sans rechargement de la fiche (fetch /cart/add.js
 *    puis rendu du tiroir par cart-2026.js), total sous le bouton, message au
 *    tap sur un parfum en rupture, erreurs affichées en ligne (plus d'alert()).
 *
 * Dépend de assets/cart-2026.js (window.HedonistCart2026) ; se désactive
 * proprement s'il est absent. Textes et format monétaire : snippet
 * hc-sticky-buy.liquid (<script type="application/json" data-hc-ux-config>).
 */
(function () {
  'use strict';

  if (window.HedonistUX) return;

  var cfg = {};
  var cfgEl = document.querySelector('[data-hc-ux-config]');
  if (cfgEl) {
    try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { cfg = {}; }
  }
  var I18N = cfg.i18n || {};
  var MONEY_FORMAT = cfg.moneyFormat || '{{amount}} €';
  var KIND = cfg.kind || '';
  var BUSY_TIMEOUT = 8000;
  var MOBILE = '(max-width: 767px)';

  function t(key, fallback, vars) {
    var s = I18N[key] || fallback || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}|\\[\\[' + k + '\\]\\]', 'g'), vars[k]);
      });
    }
    return s;
  }

  /* ----------------------------------------------------------- monnaie */

  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents, format) {
    var fmt = format || '{{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value = (parseInt(cents, 10) || 0) / 100;
    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = groupThousands(String(Math.round(value)), ',');
        break;
      case 'amount_with_comma_separator':
        out = groupThousands(value.toFixed(2).split('.')[0], '.') + ',' + value.toFixed(2).split('.')[1];
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = groupThousands(String(Math.round(value)), '.');
        break;
      case 'amount_with_space_separator':
        out = groupThousands(value.toFixed(2).split('.')[0], ' ') + ',' + value.toFixed(2).split('.')[1];
        break;
      case 'amount_no_decimals_with_space_separator':
        out = groupThousands(String(Math.round(value)), ' ');
        break;
      default:
        out = groupThousands(value.toFixed(2).split('.')[0], ',') + '.' + value.toFixed(2).split('.')[1];
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ------------------------------------------------------------ helpers */

  function cart() {
    return window.HedonistCart2026 || null;
  }

  function drawer() {
    return document.getElementById('mydiv') || document.querySelector('cart-drawer');
  }

  function drawerInner() {
    var d = drawer();
    return d ? d.querySelector('.drawer__inner') : null;
  }

  function mainForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function mainButton() {
    return document.querySelector('form[action*="/cart/add"] button.shopnowbtn, form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] .AddToCart');
  }

  function qtyInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('.flavouritemwrap [data-hc-qty]'));
  }

  /* --------------------------------------------------- état « Ajout… » */

  var busyButtons = [];
  var busyTimer = null;

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      if (btn.classList.contains('hc-ux-busy')) return;
      btn.classList.add('hc-ux-busy');
      btn.setAttribute('aria-busy', 'true');
      var overlay = document.createElement('span');
      overlay.className = 'hc-ux-busy__overlay';
      overlay.innerHTML = '<span class="hc-ux-spinner" aria-hidden="true"></span><span class="hc-ux-busy__label"></span>';
      overlay.querySelector('.hc-ux-busy__label').textContent = t('adding', 'Ajout…');
      btn.appendChild(overlay);
      if (busyButtons.indexOf(btn) === -1) busyButtons.push(btn);
    } else {
      btn.classList.remove('hc-ux-busy');
      btn.removeAttribute('aria-busy');
      var o = btn.querySelector('.hc-ux-busy__overlay');
      if (o) o.parentNode.removeChild(o);
    }
  }

  function setDrawerNote(on) {
    var d = drawer();
    var inner = drawerInner();
    if (!d || !inner) return;
    var old = inner.querySelector('.hc-ux-adding');
    if (old) old.parentNode.removeChild(old);
    d.classList.toggle('hc-ux-is-adding', !!on);
    if (!on) return;
    var note = document.createElement('div');
    note.className = 'hc-ux-adding';
    note.setAttribute('role', 'status');
    note.innerHTML = '<div class="hc-ux-adding__card"><span class="hc-ux-spinner hc-ux-spinner--dark" aria-hidden="true"></span><span class="hc-ux-adding__text"></span></div>';
    note.querySelector('.hc-ux-adding__text').textContent = t('adding_cart', 'Ajout au panier…');
    inner.appendChild(note);
  }

  function startBusy(buttons, openDrawer) {
    (buttons || []).forEach(function (b) { setBusy(b, true); });
    if (openDrawer && cart()) {
      setDrawerNote(true);
      try { cart().open(buttons && buttons[0] ? buttons[0] : null); } catch (e) { /* noop */ }
    }
    clearTimeout(busyTimer);
    busyTimer = setTimeout(endBusy, BUSY_TIMEOUT);
  }

  function endBusy() {
    clearTimeout(busyTimer);
    busyTimer = null;
    busyButtons.forEach(function (b) { setBusy(b, false); });
    busyButtons = [];
    setDrawerNote(false);
  }

  // Fin de l'état « Ajout… » : rendu du tiroir par cart-2026, ou re-rendu Dawn (renderContents), ou erreur produit.
  document.addEventListener('hc:cart:refreshed', function () { endBusy(); });

  function watchDrawer() {
    var d = drawer();
    if (!d || !window.MutationObserver) return;
    // Dawn (renderContents) remplace l'innerHTML de #CartDrawer, cart-2026 celui de .drawer__inner :
    // tout nœud ajouté qui n'est pas notre voile = panier re-rendu → fin de l'état « Ajout… ».
    new MutationObserver(function (records) {
      if (!busyTimer) return;
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type !== 'childList') continue;
        for (var j = 0; j < r.addedNodes.length; j++) {
          var n = r.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.classList.contains('hc-ux-adding') || (n.closest && n.closest('.hc-ux-adding'))) continue;
          endBusy();
          return;
        }
      }
    }).observe(d, { childList: true, subtree: true });
  }

  function watchFormError() {
    var w = document.querySelector('.product-form__error-message-wrapper');
    if (!w || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!w.hasAttribute('hidden')) {
        endBusy();
        if (cart()) { try { cart().close(); } catch (e) { /* noop */ } }
      }
    }).observe(w, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ------------------------------------------- HANG-OVER : soumission */

  // product-form.js (Dawn) gère l'envoi ; on ajoute seulement le retour visuel, en phase de capture.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !(form.getAttribute('action') || '').match(/\/cart\/add/)) return;
    if (form.closest('#mydiv, cart-drawer')) return;
    var btn = form.querySelector('[type="submit"], button.shopnowbtn');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var list = btn ? [btn] : [];
    if (sticky.button && sticky.button !== btn) list.push(sticky.button);
    startBusy(list, true);
  }, true);

  /* ------------------------------------------------- AQUAPOP : ajout */

  function aquaItems() {
    var items = [];
    qtyInputs().forEach(function (input) {
      var tile = input.closest('.flvitembox');
      var id = tile ? tile.getAttribute('data-id') : null;
      var qty = parseInt(input.value, 10) || 0;
      if (id && qty > 0) items.push({ id: id, quantity: qty });
    });
    return items;
  }

  function aquaSelection() {
    var count = 0;
    var cents = 0;
    qtyInputs().forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      var price = parseInt(input.getAttribute('data-hc-price'), 10) || 0;
      count += qty;
      cents += qty * price;
    });
    return { count: count, cents: cents };
  }

  function showInlineError(message) {
    var form = mainForm();
    if (!form) return;
    var box = form.querySelector('.hc-ux-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'hc-ux-error';
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message || t('add_error', 'Impossible d’ajouter au panier. Réessayez.');
    box.hidden = false;
    clearTimeout(box._hcTimer);
    box._hcTimer = setTimeout(function () { box.hidden = true; }, 6000);
  }

  function hideInlineError() {
    var form = mainForm();
    var box = form ? form.querySelector('.hc-ux-error') : null;
    if (box) box.hidden = true;
  }

  function addAquapop(trigger) {
    var items = aquaItems();
    if (!items.length) {
      scrollToFlavours();
      return;
    }
    hideInlineError();
    var main = mainButton();
    var list = [];
    if (main) list.push(main);
    if (sticky.button && sticky.button !== main) list.push(sticky.button);
    startBusy(list, true);

    var done = function (ok, message) {
      if (ok) {
        if (cart()) {
          cart().refresh(true); // déclenche hc:cart:refreshed → endBusy()
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } else {
        endBusy();
        if (cart()) { try { cart().close(); } catch (e) { /* noop */ } }
        showInlineError(message);
      }
    };

    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
      hcSkipHook: true
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; }, function () { return { ok: res.ok, json: null }; });
    }).then(function (r) {
      if (r.ok) done(true);
      else done(false, r.json && (r.json.description || r.json.message));
    }).catch(function () {
      done(false);
    });
  }

  function scrollToFlavours() {
    var wrap = document.querySelector('.flavouritemwrap');
    if (!wrap) return;
    try { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { wrap.scrollIntoView(); }
    wrap.classList.add('hc-ux-flash');
    setTimeout(function () { wrap.classList.remove('hc-ux-flash'); }, 1600);
  }

  // Capture : on remplace le handler jQuery d'aqua-script.js (rechargement de toute la fiche + alert()).
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.AddToCart') : null;
    if (!btn || !btn.closest('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (btn.disabled || btn.classList.contains('hc-ux-busy')) return;
    addAquapop(btn);
  }, true);

  /* ------------------------------------- AQUAPOP : total + rupture */

  var totalEl = null;

  function ensureTotal() {
    if (totalEl || KIND !== 'aquapop') return;
    var form = mainForm();
    if (!form) return;
    totalEl = document.createElement('p');
    totalEl.className = 'hc-ux-total';
    totalEl.setAttribute('aria-live', 'polite');
    form.appendChild(totalEl);
  }

  function renderTotal() {
    if (KIND !== 'aquapop') return;
    ensureTotal();
    if (!totalEl) return;
    var sel = aquaSelection();
    if (sel.count > 0) {
      totalEl.textContent = t(sel.count === 1 ? 'selected_one' : 'selected_other', '{{ count }} article(s)', { count: sel.count }) + ' · ' + formatMoney(sel.cents, MONEY_FORMAT);
      totalEl.classList.add('is-active');
    } else {
      totalEl.textContent = t('choose_flavour', 'Choisissez un parfum ci-dessus');
      totalEl.classList.remove('is-active');
    }
  }

  var toastTimer = null;
  function toast(message) {
    var el = document.querySelector('.hc-ux-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'hc-ux-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  document.addEventListener('click', function (event) {
    var tile = event.target.closest ? event.target.closest('.flvitembox.is-soldout') : null;
    if (!tile) return;
    toast(t('soldout_tap', 'Ce parfum est en rupture de stock. Choisissez un autre parfum.'));
  });

  /* ------------------------------------------- barre d'achat fixe */

  var sticky = { el: null, button: null, label: null, price: null, mq: null };

  // Visibilité du bouton principal mesurée directement (IntersectionObserver seul ne se déclenche pas dans un onglet en arrière-plan).
  function ctaVisible() {
    var main = mainButton();
    if (!main) return false;
    var r = main.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.width > 0 && r.bottom > 0 && r.top < vh;
  }

  // Regroupe les mises à jour : requestAnimationFrame quand il tourne, setTimeout sinon (onglet en arrière-plan, webviews).
  var pending = {};
  function once(key, fn, delay) {
    if (pending[key]) return;
    pending[key] = true;
    var run = function () {
      if (!pending[key]) return;
      pending[key] = false;
      fn();
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    setTimeout(run, delay || 50);
  }

  function stickyUpdateSoon() {
    once('sticky', stickyUpdate);
  }

  function stickyInit() {
    sticky.el = document.querySelector('[data-hc-sticky]');
    if (!sticky.el) return;
    if (sticky.el.parentNode !== document.body) document.body.appendChild(sticky.el); // position: fixed hors de tout ancêtre transformé
    sticky.button = sticky.el.querySelector('[data-hc-sticky-btn]');
    sticky.label = sticky.el.querySelector('[data-hc-sticky-label]');
    sticky.price = sticky.el.querySelector('[data-hc-sticky-price]');
    sticky.mq = window.matchMedia ? window.matchMedia(MOBILE) : null;
    sticky.baseLabel = sticky.button ? sticky.button.textContent.trim() : '';

    var main = mainButton();
    if (main && window.IntersectionObserver) {
      new IntersectionObserver(stickyUpdateSoon, { threshold: [0, 0.01, 1] }).observe(main);
    }
    window.addEventListener('scroll', stickyUpdateSoon, { passive: true });
    window.addEventListener('resize', stickyUpdateSoon);
    window.addEventListener('orientationchange', stickyUpdateSoon);

    var d = drawer();
    if (d && window.MutationObserver) {
      new MutationObserver(stickyUpdate).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
    if (sticky.mq) {
      if (sticky.mq.addEventListener) sticky.mq.addEventListener('change', stickyUpdate);
      else if (sticky.mq.addListener) sticky.mq.addListener(stickyUpdate);
    }

    sticky.button.addEventListener('click', function (event) {
      event.preventDefault();
      if (sticky.button.classList.contains('hc-ux-busy')) return;
      if (KIND === 'aquapop') {
        addAquapop(sticky.button);
        return;
      }
      var mainBtn = mainButton();
      if (!mainBtn) return;
      if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
      mainBtn.click(); // → submit → product-form.js + état « Ajout… » (capture ci-dessus)
    });

    stickyRender();
    stickyUpdate();
  }

  function stickyRender() {
    if (!sticky.el) return;
    if (KIND === 'aquapop') {
      var sel = aquaSelection();
      if (sel.count > 0) {
        sticky.label.textContent = t(sel.count === 1 ? 'selected_one' : 'selected_other', '{{ count }} article(s)', { count: sel.count });
        sticky.price.textContent = formatMoney(sel.cents, MONEY_FORMAT);
        sticky.button.classList.remove('is-secondary');
        setButtonText(sticky.button, sticky.baseLabel);
      } else {
        sticky.label.textContent = t('choose_flavour_short', 'Choisissez votre parfum');
        sticky.price.textContent = '';
        sticky.button.classList.add('is-secondary');
        setButtonText(sticky.button, t('choose_flavour_btn', 'Choisir'));
      }
      return;
    }
    // HANG-OVER : pack actif (libellé + prix affichés dans le sélecteur), sinon prix de base.
    var active = document.querySelector('.selectpackbox.active');
    var label = active ? active.querySelector('.pkgcon h5') : null;
    var price = active ? active.querySelector('.selectpricenew') : null;
    sticky.label.textContent = label ? label.textContent.trim() : (cfg.productTitle || '');
    sticky.price.textContent = price ? price.textContent.trim() : (cfg.basePrice || '');
    var mainBtn = mainButton();
    var disabled = !!(mainBtn && (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true'));
    sticky.button.disabled = disabled;
  }

  function setButtonText(btn, text) {
    var node = btn.querySelector('[data-hc-sticky-text]');
    if (node) node.textContent = text;
    else btn.textContent = text;
  }

  function stickyUpdate() {
    if (!sticky.el) return;
    var d = drawer();
    var mobile = sticky.mq ? sticky.mq.matches : window.innerWidth < 768;
    var show = mobile && !ctaVisible() && !(d && d.classList.contains('active'));
    sticky.el.hidden = !show;
    sticky.el.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('hc-sticky-on', show);
  }

  /* ---------------------------------------------- rafraîchissements */

  function schedule() {
    once('render', function () {
      renderTotal();
      stickyRender();
      stickyUpdate();
    });
  }

  // Les scripts historiques (jQuery) modifient les quantités et le pack actif dans leurs propres handlers : on recalcule juste après.
  document.addEventListener('click', function () { setTimeout(schedule, 0); });
  document.addEventListener('input', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('hc:cart:refreshed', schedule);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { endBusy(); schedule(); } });

  function init() {
    watchDrawer();
    watchFormError();
    renderTotal();
    stickyInit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.HedonistUX = {
    busy: function (on) { on ? startBusy([mainButton()], true) : endBusy(); },
    addAquapop: addAquapop,
    refresh: schedule,
    update: stickyUpdate,
    toast: toast
  };
})();
